/**
 * Formats a number as Colombian Peso (COP)
 * Uses period as thousands separator and comma as decimal separator
 */
export function formatCOP(value: number | undefined | null): string {
  if (value === undefined || value === null || isNaN(value)) return '$ 0';
  return `$ ${value.toLocaleString('es-CO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

/**
 * Formats a number as US Dollar (USD)
 * Uses comma as thousands separator and period as decimal separator
 */
export function formatUSD(value: number | undefined | null): string {
  if (value === undefined || value === null || isNaN(value)) return '$ 0.00';
  return `$ ${value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/**
 * Formats a number as percentage with max 2 decimal places
 */
export function formatPercentage(value: number | undefined | null): string {
  if (value === undefined || value === null || isNaN(value)) return '0%';
  return `${(value * 100).toFixed(2)}%`;
}

/**
 * Parses a numeric input string, handling thousands separators
 * Accepts input with or without separators
 */
export function parseNumericInput(input: string): number {
  // Remove all non-numeric characters except decimal point and comma
  const cleaned = input.replace(/[^\d.,]/g, '');

  // Handle both comma and period as decimal separator
  // If there's a comma after the last period, treat comma as decimal
  const lastPeriod = cleaned.lastIndexOf('.');
  const lastComma = cleaned.lastIndexOf(',');

  let normalized: string;
  if (lastComma > lastPeriod) {
    // Comma is decimal separator (European style)
    normalized = cleaned.replace(/\./g, '').replace(',', '.');
  } else {
    // Period is decimal separator (US style)
    normalized = cleaned.replace(/,/g, '');
  }

  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? 0 : parsed;
}

/**
 * Formats a number for display in input fields
 */
export function formatNumberForInput(value: number): string {
  if (value === 0) return '';
  return value.toLocaleString('es-CO');
}
